/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

export const accountReassignmentSchema = z.object({ "createdAt": z.string().datetime(), "id": z.string().uuid(), "newAccountId": z.string().uuid().nullish(), "oldAccountId": z.string().uuid().nullish() });
export type AccountReassignment = z.infer<typeof accountReassignmentSchema>;
